import { EdgeTypes } from '@xyflow/react';
import CustomEdge from './CustomEdge';
import FloatingEdge from './FloatingEdge';

// Maps the edge type string to our components
const edgeTypes: EdgeTypes = Object.freeze({
  custom: CustomEdge,
  floating: FloatingEdge,
});

export default edgeTypes;
